import React, {Component} from 'react';
import {connect} from "react-redux";
import {hideModal} from "../../../actions/nodeEditorPanelActions";
import Predicate from "../components/Predicate/";
import {clickedNodeAction} from "../../../actions/clickedNodeActions";
import defaultPredicateOption from "../components/Predicate/const/defaultPredicateOption";
import PanelLayout from "../components/PanelLayout";
import ToggleMaxResultBox from '../components/ToggleMaxResultBox';

class ItemFilterPanel extends Component {
    constructor(props) {
        super(props);

        this.hasPredicate = this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.predicate;

        this.state = {
            predicate: this.hasPredicate ? this.props.clickedNodeInfo.extras.options.predicate : {
                type: "and",
                predicates: [
                    defaultPredicateOption
                ]
            }
        };
    }

    componentDidMount() {
        if (this.props.clickedNodeInfo.extras.options && this.props.clickedNodeInfo.extras.options.predicate) {
            this.setState({predicate: this.props.clickedNodeInfo.extras.options.predicate}, () => {
                this.updateOptions(this.props.clickedNodeInfo.extras.options.predicate);
            });
        } else {
            this.updateOptions(this.state.predicate);
        }
    }

    updateOptions(predicate) {
        const clickedNodeInfo = this.props.clickedNodeInfo;
        let predicateInfo = Object.assign({}, clickedNodeInfo);
        if (!Object.prototype.hasOwnProperty.call(predicateInfo.extras, "options")) {
            predicateInfo.extras.options = {};
        }
        // predicateInfo.extras.options = {
        //     ...predicateInfo.extras.options,
        //     predicate
        // };
        predicateInfo.extras.options.predicate = predicate;

        this.props.clickedNodeAction(predicateInfo);
    }

    render() {
        return (
            <PanelLayout>
                <ToggleMaxResultBox/>
                <Predicate updateOptions={(predicate) => this.updateOptions(predicate)}
                           predicate={this.state.predicate}/>
            </PanelLayout>
        );
    }
}

function mapStateToProps(state) {
    return {
        content: state.modalInfo.content,
        node: state.modalInfo.node,
        clickedNodeInfo: state.clickedNodeInfo
    }
}

export default connect(mapStateToProps, {hideModal, clickedNodeAction})(ItemFilterPanel);